"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCampaignEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const display_1 = require("../display");
const media_1 = require("../media");
const user_1 = require("../user");
class MediaCampaignEntity {
    id;
    reqId;
    display;
    playlists;
    campaigns;
    title;
    media;
    owner;
    retentionId;
    price;
    statistics;
    isMy;
    dates;
    /**
     * @deprecated
     */
    accepted;
    mediaDuration;
    isExpired;
    status;
    isPaid;
    deliveryPolicy;
    deliverySettlement;
    removed;
    metadata;
    reason;
    paymentLink;
    updatedAt;
    createdAt;
}
exports.MediaCampaignEntity = MediaCampaignEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the media campaign",
        example: "123456789",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Request identifier",
        example: "req_987654321",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "reqId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Associated display entity",
        type: display_1.DisplayFlattenEntity,
    }),
    __metadata("design:type", display_1.DisplayFlattenEntity)
], MediaCampaignEntity.prototype, "display", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of playlist identifiers",
        type: [String],
        example: ["playlist_1", "playlist_2"],
    }),
    __metadata("design:type", Array)
], MediaCampaignEntity.prototype, "playlists", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of campaign identifiers",
        type: [String],
        example: ["123456789", "987654321"],
    }),
    __metadata("design:type", Array)
], MediaCampaignEntity.prototype, "campaigns", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Campaign title. Falls back to the associated media title for legacy campaigns.",
        example: "Summer Sale Campaign",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "title", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Associated media entity",
        type: media_1.MediaEntity,
    }),
    __metadata("design:type", media_1.MediaEntity)
], MediaCampaignEntity.prototype, "media", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Campaign owner user",
        type: user_1.UserEntity,
    }),
    __metadata("design:type", user_1.UserEntity)
], MediaCampaignEntity.prototype, "owner", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Retention identifier",
        example: "retention_abc123",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "retentionId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Campaign pricing information",
        type: "object",
        properties: {
            amount: {
                type: "number",
                description: "Total amount",
                example: 100.5,
            },
            currency: {
                type: "string",
                description: "Currency code",
                example: "EUR",
            },
            fees: {
                type: "object",
                properties: {
                    admefy: { type: "number", description: "Admefy commission", example: 10.05 },
                    displayOwner: { type: "number", description: "Display owner commission", example: 80.4 },
                    displayProvider: {
                        type: "number",
                        description: "Display provider commission",
                        example: 5.02,
                    },
                    displayOwnerReferral: {
                        type: "number",
                        description: "Display owner referral commission",
                        example: 5.03,
                    },
                },
            },
        },
    }),
    __metadata("design:type", Object)
], MediaCampaignEntity.prototype, "price", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Campaign statistics by reqId",
        type: "object",
        properties: {
            approvals: { type: "number", description: "Number of approvals", example: 5 },
            rejections: { type: "number", description: "Number of rejections", example: 1 },
            pendings: { type: "number", description: "Number of pending requests", example: 3 },
        },
    }),
    __metadata("design:type", Object)
], MediaCampaignEntity.prototype, "statistics", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if the campaign is owned by the current user",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaCampaignEntity.prototype, "isMy", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Scheduled dates with specific hours, hours are in seconds",
        type: [Object],
        example: [
            {
                date: "2025-07-15",
                hours: [
                    0, 3600, 7200, 10800, 14400, 18000, 21600, 25200, 28800, 32400, 36000, 39600, 43200,
                    46800, 50400, 54000, 57600, 61200, 64800, 68400, 72000, 75600, 79200, 82800,
                ],
            },
        ],
    }),
    __metadata("design:type", Array)
], MediaCampaignEntity.prototype, "dates", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: 'Indicates if the campaign was accepted (deprecated field), use "status" instead',
        deprecated: true,
        example: true,
    })
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Boolean)
], MediaCampaignEntity.prototype, "accepted", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Media duration in seconds",
        example: 30,
    }),
    __metadata("design:type", Number)
], MediaCampaignEntity.prototype, "mediaDuration", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if the campaign has expired",
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaCampaignEntity.prototype, "isExpired", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Current status of the media campaign",
        enum: ["pending", "approved", "rejected", "removed", "awaiting_payment", "completed"],
        example: "pending",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "status", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if the campaign has been paid",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaCampaignEntity.prototype, "isPaid", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Immutable delivery settlement policy", type: Object }),
    __metadata("design:type", Object)
], MediaCampaignEntity.prototype, "deliveryPolicy", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Auditable delivery settlement result", type: Object }),
    __metadata("design:type", Object)
], MediaCampaignEntity.prototype, "deliverySettlement", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if the campaign has been removed",
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaCampaignEntity.prototype, "removed", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Additional metadata associated with the campaign",
        example: { key: "value" },
        type: Object,
    }),
    __metadata("design:type", Object)
], MediaCampaignEntity.prototype, "metadata", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Reason for rejection if the campaign was rejected",
        example: "Inappropriate content",
        type: String,
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "reason", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Payment link for the campaign, only present if the campaign is `awaiting_payment` status",
        example: "https://payment.example.com/campaign/123456789",
        type: String,
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "paymentLink", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update date and time",
        example: "2025-07-11T10:30:00Z",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "updatedAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation date and time",
        example: "2025-07-10T15:45:00Z",
    }),
    __metadata("design:type", String)
], MediaCampaignEntity.prototype, "createdAt", void 0);
